module.exports = __webpack_public_path__ + "img/GreenPurpleDoubleClircle400.73b78a01.png";